function SkeletonCard({ lines = 3 }: { lines?: number }) {
  return (
    <div className='rounded-2xl border border-sd-border bg-sd-card p-5 space-y-3'>
      <div className='h-4 w-32 rounded bg-sd-muted animate-pulse' />
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className={`h-3 rounded bg-sd-muted animate-pulse ${i === lines - 1 ? 'w-3/4' : 'w-full'}`}
        />
      ))}
    </div>
  );
}

export function OrderDetailsSkeleton() {
  return (
    <div className='grid grid-cols-1 xl:grid-cols-[1fr_360px] gap-5'>
      <div className='flex flex-col gap-5'>
        {[1, 2, 3, 4, 5].map((i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
      <div className='flex flex-col gap-5'>
        {[1, 2].map((i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    </div>
  );
}
